module.exports = __webpack_public_path__ + "img/20.760dbdf6.png";